import React, { ReactElement } from 'react';
import './Modal.scss';
import closeIcon from '../imgs/icons/close.svg';

export default function Modal(props: Props) {
	return (
		<div className="modal__outer-container">
			<div className="modal__inner-container">
				<div className="modal__backdrop" onClick={props.onClose}></div>
				<div className="modal__modal">

					<div className="modal__content">
						{props.children}
					</div>
					
					<div className="modal__close" onClick={props.onClose}><img src={closeIcon} style={{height: 15}} alt="Close" /></div>
					
					{!!props.renderActions &&
						<div className="modal__actions">
							{props.renderActions()}
						</div>
					}
				</div>
			</div>
		</div>
	);
}

interface Props {
    onClose: () => void;
    children: ReactElement;
    renderActions?: () => ReactElement;
}
